import React, { useState } from 'react'
import styles from './Copy.module.css'

export const Copy = ({
    item,
    showText = true,
    value,
    color = 'black'
}: {
    item: React.ReactNode | string
    showText?: boolean
    value?: string | null
    color?: string
}) => {
    const [isCopied, setIsCopied] = useState(false)
    const valueToCopy = value || item

    const handleCopyClick = async () => {
        try {
            await navigator.clipboard.writeText(valueToCopy as string)
            setIsCopied(true)
            setTimeout(() => {
                setIsCopied(false)
            }, 3000)
        } catch (err) {
            console.error('Failed to copy text: ', err)
        }
    }
    if (item === '-') {
        return null
    }
    if (item) {
        return (
            <div className={styles.root}>
                {/* Skipped entirely rather than left empty, which still spent its margin on nothing. */}
                {showText && <span className={styles.label}>{item}</span>}
                {/* Confirming with a checkmark in place of the icon keeps the button one size, where
                    the old "Copied!" text made everything around it jump. */}
                <button onClick={handleCopyClick} className={styles.button} aria-label={isCopied ? 'Copied' : 'Copy'}>
                    <i className={`${styles.icon} material-icons`} style={{ color }}>
                        {isCopied ? 'check' : 'content_copy'}
                    </i>
                </button>
            </div>
        )
    } else {
        return null
    }
}
